import type { MouseEvent } from 'react';

import { Button } from '#/components/Button/Button';
import { Icon } from '#/components/Icon/Icon';
import { Text } from '#/components/Text/Text';
import { useI18n } from '#/i18n/hooks/useI18n';
import { searchGetPathSwitch } from '#/modules/search/routing/helpers/searchGetPathSwitch';
import type { SearchType } from '#/modules/search/types/SearchType';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

import {
  MobileSearchMenuPopularSearchesBody,
  MobileSearchMenuPopularSearchesHolder,
  MobileSearchMenuPopularSearchesLinkWithIcon,
} from './MobileSearchMenuPopularSearches.styles';

type Props = {
  onSearch: (event: MouseEvent<HTMLElement>, query: string) => void;
  popularSearches: string[];
  searchType: SearchType;
};

export function MobileSearchMenuPopularSearches({
  popularSearches,
  searchType,
  onSearch,
}: Props) {
  const { i18n, locale } = useI18n();

  return (
    <MobileSearchMenuPopularSearchesHolder>
      <MobileSearchMenuPopularSearchesBody>
        <Text tag="div" styleAs="h4" style={{ lineHeight: 1, marginBottom: 0 }}>
          {i18n('Popular searches')}
        </Text>
        {popularSearches.map((ps: string) => (
          <MobileSearchMenuPopularSearchesLinkWithIcon
            key={`${searchType}-${ps}`}
          >
            <Icon name="search" colorName="lightContentGrey" size={18} />
            <Button
              type="link-with-state"
              variant="tertiary-grey"
              size="small"
              noPadding
              noBold
              qaId="mobile-header-search-link"
              to={searchGetPathSwitch({
                locale,
                q: ps,
                filtersByName: { type: searchType },
                embedSearchWidgetId: null,
              })}
              state={{ searchFrom: 'Mobile Search Link' }}
              onClick={(event) => {
                trackClicked('Popular Searches', {
                  search_term: ps,
                  selected_listing_type: searchType,
                });
                onSearch(event, ps);
              }}
            >
              {ps}
            </Button>
          </MobileSearchMenuPopularSearchesLinkWithIcon>
        ))}
      </MobileSearchMenuPopularSearchesBody>
    </MobileSearchMenuPopularSearchesHolder>
  );
}
